var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHousingCount = function SvgHousingCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M0 0h43v43H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#housing_count_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-415-1349h1440V778H-415z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F2FAF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.007 25.546a6.668 6.668 0 0 1-7.187-.157c-2.806-1.878-3.849-5.568-2.456-8.686 1.393-3.118 4.805-4.728 8.03-3.79 3.225.939 5.296 4.144 4.874 7.545l6.925 4.641c.238.158.404.406.462.69l.575 2.828a.963.963 0 0 1-.729 1.14l-2.766.574a1.047 1.047 0 0 1-.802-.157l-.84-.552a1.168 1.168 0 0 1-.488-.737l-.202-1.002-.826.177a1.256 1.256 0 0 1-.963-.186 1.31 1.31 0 0 1-.552-.827l-.172-.844-.988.21h-.027a1.106 1.106 0 0 1-.829-.171l-1.039-.696Zm-4.929-4.787c-.41 0-.81-.123-1.152-.353h.005a2.173 2.173 0 0 1-.795-2.6 2.092 2.092 0 0 1 2.338-1.305c.984.19 1.7 1.066 1.708 2.09.01 1.024-.69 1.912-1.672 2.12a2.09 2.09 0 0 1-.432.048Zm-.153-2.892a.745.745 0 0 0-.475.331v.014a.777.777 0 0 0 .26.996.74.74 0 0 0 .995-.168.782.782 0 0 0 .034-.786.748.748 0 0 0-.814-.387Z",
    fill: "#58B847"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "housing_count_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-415 -1349)",
    d: "M0 0h1440v2127H0z"
  })))));
};
export default SvgHousingCount;